export default __webpack_public_path__ + "media/Zach-Evans-desktop.461a2988.jpg";